import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import Divider from '@material-ui/core/Divider';

import config from "../../config/config";
import axios from 'axios';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
        overflowX: 'auto',
    },
    table: {
        minWidth: 700,
    },
});

class TaskDialog extends Component {
    state = {
        open: this.props.open,
        scroll: 'paper',
        requiredFields: [{
            id: 0,
            required: false,
            attachment: false,
            type: "Text",
            textType: "free text",
            attachment_list: []
        }],
        index: 0,
        task: {
            task_Assignee: "",
            description: "",
            due_date: "",
            questions: [{
                id: 0,
                question_type: "Text",
                question_text: "",
                response:"No Response",

            }],
            file: []
        },
        tempID: 0,
        selectedOption:null

    };

    componentDidUpdate(prevProps){
        // console.log(prevProps.open + "   " + this.props.open)
        if (prevProps.open !== this.props.open)
        this.setState({open:this.props.open});
    }

    //handle close dialog
    handleClose = () => {
        this.setState({ open: false });
        this.props.close();
    };
    //handle submit dialog
    handleSubmit = () =>{
        let postObj = this.createSubmitObj();
        let isRequiredFieldFilled = true;
        for (var key in postObj) {
            console.log(postObj[key]);
            if (postObj[key] == "") {
                console.log(key+" is null value")
                isRequiredFieldFilled = false;
            }
        }

        if (isRequiredFieldFilled) {
            console.log("submit data");
            console.log(postObj);
            axios.post(config.tasks(this.props.id), postObj)
                .then(res=>{
                    console.log(res)
                    this.props.update()

                })
                .catch(error=>{console.log(error.response)});

            this.setState({ open: false });

            this.props.close();
        } else {
            alert("Please fill all the required field");
        }
    };

    createSubmitObj() {
        let postObj = {
            assigned_user: this.state.task.assigned_user,
            rationales: this.state.task.rationales,
            due_date: this.state.task.due_date,
            follow_up_action: this.state.task.follow_up_action,
            alert: 1,
            created_user_id: 1
        };
        return postObj;
    }

    handleRadioGroupChange = (e, id) => {
        let updateField = this.state.requiredFields.find(o=>o.id == id);
        let updateqFieldIndex = this.state.requiredFields.indexOf(updateField);
        updateField.textType = e.target.value;
        this.setState(state => {this.state.requiredFields[updateqFieldIndex] = updateField});

        let updateObj = this.state.task.questions.find(o=>o.id == id);
        let updatequestionIndex = this.state.task.questions.indexOf(updateObj);
        updateObj.value = e.target.value;
        this.setState(state => {this.state.task.questions[updatequestionIndex] = updateObj});

        this.forceUpdate();
    };

    handleTextfieldChange = (e) =>{
        let name = e.target.name;
        let value = e.target.value;
        // console.log("in text field change")
        // console.log(name)
        // console.log(value)
        this.setState(state =>{this.state.task[name] = value;});
    };
    handleChange = name => selectedOption => {
        this.setState({ selectedOption });
        // console.log(`Option selected:`, selectedOption);
        if (selectedOption)
        {        
            // let name = selectedOption.label;
            let value = selectedOption.value;
            // console.log(name)
            // console.log(value)
            this.setState(state =>{this.state.task[name] = value;});
        }
    }

    handleFileUpload = (e) => {
        let value = e.target.value;
        this.setState(state =>{this.state.task["file"].push(value);});
    };

    handleQuestionAdd = (id) => {
        let obj = {
            id: id,
            question_type: "",
            question_text: "",
            value: ""
        };
        this.setState(state => {this.state.task.questions.push(obj);});
    };

    handleDueDateChange = (date) => {
        // console.log('handleDueDateChange : ' + date)
        this.setState(state =>{this.state.task.due_date = date;})
        this.forceUpdate()
    }

    handleQuestionDelete = (id) => {

        let removeobj = this.state.requiredFields.find(o=>o.id == id);
        let removeobjIndex = this.state.requiredFields.indexOf(removeobj);

        let removequestion = this.state.task.questions.find(o=>o.id == id);
        let removequestionIndex = this.state.task.questions.indexOf(removequestion);

        if (removeobjIndex != -1){
            this.setState(state => {this.state.requiredFields.splice(removeobjIndex, 1)});
        }
        if (removequestionIndex != -1){
            this.setState(state => {this.state.task.questions.splice(removequestionIndex, 1)});
        }
        this.forceUpdate();
    };


    QuestionFileUpdateRequest = (formData) => {
        return axios.post(config.attachment, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then((res)=>{
            console.log("upload file res");
            console.log(res);
            this.setState({ tempID: res.data.id });
            return res.data.id;
        })
            .catch(err=>{ console.log(err.response); });
    };

    handleQuestionUpdate = (e, id, questionType) => {
        let updateObj = this.state.task.questions.find(o=>o.id == id);
        let updatequestionIndex = this.state.task.questions.indexOf(updateObj);

        if(e.target.files != null){
            let requiredField = this.state.requiredFields.find(o=>o.id == id);
            let requiredFieldIndex = this.state.requiredFields.indexOf(requiredField);
            console.log(this.state.requiredFields);
            requiredField.attachment_list.push(e.target.files[0]);
            this.setState(state => {this.state.requiredFields[requiredFieldIndex] = requiredField});
        }


        let name = e.target.name;
        let value = e.target.value;

        if (name == "attachment_id"){
            let attachment = e.target.files[0];

            var formData = new FormData();
            var uploads = attachment;
            console.log(uploads);
            formData.append("file", uploads);
            console.log ("formdata");
            console.log(formData);

            this.QuestionFileUpdateRequest(formData).then(data => {
                updateObj[name] = this.state.tempID;
                console.log("updateobj");
                console.log(updateObj);
            });

        }else{
            updateObj[name] = value;
        }

        // console.log (questionType);
        updateObj.question_type = questionType;

        this.setState(state => {this.state.task.questions[updatequestionIndex] = updateObj},()=>{console.log(this.state.task)});
    };

    render() {
        let requiredField = {
            id: 0,
            title: "",
            required: false,
            attachment: false,
            type: "text"
        };
        const suggestions = this.props.users ? this.props.users.map(user=>({
            value: user.email,
            label: user.email
        })) : undefined;
        // console.log("in dialog render")
        // console.log(this.props.users)
        return (
            <Dialog
                open={this.state.open}
                //onClose={this.handleClose}
                scroll={this.state.scroll}
                aria-labelledby="scroll-dialog-title"
            >
                <DialogTitle id="scroll-dialog-title">{"Create Task"}</DialogTitle>
                <DialogContent style={{ width: "55vh", height: "100vh" }}>
                    <DialogContentText>
                            Staff in charge
                    </DialogContentText>
                    {/*<SearchableDropDown
                        options= {suggestions}
                        changeHandler={this.handleChange("task_Assignee")}
                        placeholder={"Select a user"}
                    />*/}
                    <TextField
                        id="name"
                        type="text"
                        style={{ width: "20vw" }}
                        helperText="Staff name and designation"
                        name="assigned_user"
                        required={true}
                        onChange = {this.handleTextfieldChange}
                    />
                    <div style={{ height: "1vh" }}></div>
                    <Divider />
                    <br/>
                    <DialogContentText>
                                Due date
                    </DialogContentText>
                    <DatePicker
                        selected={this.state.task.due_date}
                        onChange={this.handleDueDateChange}
                    />

                    <div style={{ height: "1vh" }}></div>
                    <Divider />
                    <br/>
                    <DialogContentText>
                            Risk rationales
                    </DialogContentText>
                    <TextField
                        id="name"
                        type="text"
                        multiline = {true}
                        fullWidth
                        helperText="Overall description regarding this risk"
                        name="rationales"
                        required={true}
                        onChange = {this.handleTextfieldChange}
                    />
                    <div style={{ height: "1vh" }}></div>
                    <Divider />
                    <br/>
                    <DialogContentText>
                        Please fill in the follow up actions
                    </DialogContentText>

                    <TextField
                        id="title"
                        type="email"
                        multiline = {true}
                        fullWidth
                        name = "follow_up_action"
                        required="required"
                        onChange = {this.handleTextfieldChange}
                    />
                </DialogContent>
                <DialogActions>
                    <Button color="primary">
                        Save
                    </Button>
                    <Button onClick={this.handleSubmit}>
                        Create
                    </Button>
                    <Button onClick={this.handleClose} color="secondary">
                        Discard
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

export default withStyles(styles)(TaskDialog)


// WEBPACK FOOTER //
// ./src/components/KRI/TaskDialog.js